import React from 'react'

const Lines = () => {
  return (
    <div className=" py-10 text-center text-text dark:text-darktext">
    <h1 className="sm:text-4xl text-3xl font-bold mb-4 text-balance">Sistema de Líneas</h1>
    <p className="text-base sm:text-2xl w-11/12 md:w-3/4 mx-auto  text-balance">
      Nuestra plataforma te permite gestionar líneas de sorteos de forma continua, cada una con múltiples listas de boletos. 
    </p>
  
   
  </div>
  )
}

export default Lines